import { z } from "zod";

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.unknown()).default({}),
  }),
});

export function successSchema<T extends z.ZodTypeAny>(data: T) {
  return z.object({ data, meta: z.record(z.unknown()).default({}) });
}
export function envelopeSchema<T extends z.ZodTypeAny>(data: T) {
  return z.union([successSchema(data), apiErrorSchema]);
}
